import Box from '@mui/material/Box';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslate, MenuItemLink, MenuProps, useSidebarState, Link } from 'react-admin';

import MenuOptions from './SidebarOptions';
import { LoadingSection } from '../common/LoadingSection';
import usePermissionMiddleware from '../common/usePermissionMiddleware';
import MultiLevelMenu from './MultilevelMenu';

const Menu = ({ dense = false }: MenuProps) => {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    const translate = useTranslate();
    const [open, setOpen] = useSidebarState();
    const { isLoading } = usePermissionMiddleware();

    const hasPermission = (module: string) => {
        if (!module) return true;
        return permissions?.some(
            (permGroup: any) =>
                permGroup?.name === module &&
                Array.isArray(permGroup.permissions) &&
                permGroup.permissions.some((p: any) => !p.deleted),
        );
    };

    const hasSubmenuPermission = (children: any[]) => {
        return children?.some(child => hasPermission(child.permission));
    };
    return (
        <Box
            sx={{
                width: open ? 226 : 0,
                overflow: 'hidden',
                transition: theme =>
                    theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                borderRight: '1px solid #e0e0e0',
                paddingTop: '20px',
                paddingBottom: '20px',
            }}
        >
            {open &&
                (isLoading ? (
                    <div style={{ padding: '100px 0', width: '100%' }}>
                        <LoadingSection linear={true} />
                    </div>
                ) : (
                    MenuOptions.map((subMenuOptions, index) => (
                        <div key={index}>
                            {subMenuOptions.map((option: any, idx: number) => {
                                const userHasAccess = hasPermission(option.permission);
                                const hasChildPermission = hasSubmenuPermission(option.children);
                                if (option.name === 'Cron Jobs' && !userHasAccess) {
                                    return null;
                                }
                                if (option.children.length > 0) {
                                    return hasChildPermission ? (
                                        <div key={idx}>
                                            <MultiLevelMenu
                                                option={option}
                                                permissions={permissions}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            key={idx}
                                            className="flex justify-between w-full px-4 py-2 text-gray-500"
                                        >
                                            <div className="flex items-center">
                                                {option.icon}
                                                <span className="ml-2 text-sm">
                                                    {translate(option.name)}
                                                </span>
                                            </div>
                                            <LockIcon
                                                style={{ fontSize: '15px' }}
                                                className="ml-2"
                                            />
                                        </div>
                                    );
                                }

                                return (
                                    <div
                                        key={idx}
                                        className="flex justify-between hover:bg-gray-200"
                                    >
                                        {userHasAccess ? (
                                            <Link
                                                to={option?.to}
                                                target={option?.openInNewTab ? '_blank' : '_self'}
                                                className="flex w-full justify-between hover:bg-gray-200"
                                            >
                                                <MenuItemLink
                                                    className="w-full"
                                                    to={option.to}
                                                    state={{ _scrollToTop: true }}
                                                    primaryText={translate(option.name, {
                                                        smart_count: 2,
                                                    })}
                                                    leftIcon={option.icon}
                                                    dense={dense}
                                                    target={
                                                        option?.openInNewTab ? '_blank' : '_self'
                                                    }
                                                />
                                                <div className="icon pr-5 flex my-auto text-black">
                                                    {option?.sideIcon}
                                                </div>
                                            </Link>
                                        ) : (
                                            <div className="flex w-full justify-between px-4 py-2 text-gray-500">
                                                <div className="flex items-center">
                                                    {option.icon}
                                                    <span className="ml-2 text-sm">
                                                        {translate(option.name)}
                                                    </span>
                                                </div>
                                                <LockIcon
                                                    style={{ fontSize: '15px' }}
                                                    className="ml-2"
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ))
                ))}
        </Box>
    );
};

export default Menu;
